import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as constants from '../constants'
import type { Plugin } from '../plugin'

/**
 * Releases the plugin-owned current organization target when organization
 * editing finishes.
 */
export const releaseCurrentEntityTargetOnEditingComplete = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    rxjs
      .merge(
        plugin.collection.plugins.editingPlugin.feature.actions.submit.success.observe(),
        plugin.collection.plugins.editingPlugin.feature.actions.discard.success.observe(),
      )
      .pipe(
        rxjs.filter(action => {
          const current = action.data.request.current
          return (
            current !== true &&
            current?.target === constants.CURRENT_ENTITY_TARGET
          )
        }),
        rxjs.map(action =>
          feature.actions.releaseCurrentEntityTarget.request
            .from(action)
            .create(),
        ),
      ),
)
